import { createRoute, lazyRouteComponent } from "@tanstack/react-router";

import { appLayoutRoute } from "../../router/rootRoutes";

const settingsRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/settings",
  component: lazyRouteComponent(() => import("./SettingsPage"), "SettingsPage"),
});

const onboardingRoute = createRoute({
  getParentRoute: () => appLayoutRoute,
  path: "/onboarding",
  component: lazyRouteComponent(() => import("./OnboardingPage"), "OnboardingPage"),
});

export const profileRoutes = [settingsRoute, onboardingRoute] as const;
